import { useId } from "react";

import Box from "ds/components/Box";
import Tile from "ds/components/Tile";
import { LogoGithub, EditNote } from "components/icons/generated";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";

import { GitHubEnterpriseIntegrationManageMode } from "./types";

type VCSIntegrationsManageGitHubEnterpriseHeaderProps = {
  integrationManageMode: GitHubEnterpriseIntegrationManageMode;
  setIntegrationManageMode: (mode: GitHubEnterpriseIntegrationManageMode) => void;
};

const VCSIntegrationsManageGitHubEnterpriseHeader = ({
  integrationManageMode,
  setIntegrationManageMode,
}: VCSIntegrationsManageGitHubEnterpriseHeaderProps) => {
  const labelId = useId();

  return (
    <Box direction="column" justify="center" align="center" margin="x-large 0 0">
      <FullScreenModalBodyHeader
        noMargin
        title="Do you want to use our wizard or enter the details manually?"
        titleId={labelId}
      />

      <Box
        fullWidth
        gap="large"
        margin="x-large 0"
        role="radiogroup"
        aria-required
        aria-labelledby={labelId}
      >
        <Tile
          icon={LogoGithub}
          title="Set up via wizard"
          indicator="radio"
          selected={integrationManageMode === "wizard"}
          onClick={() => setIntegrationManageMode("wizard")}
        />

        <Tile
          icon={EditNote}
          title="Set up manually"
          indicator="radio"
          selected={integrationManageMode === "manual"}
          onClick={() => setIntegrationManageMode("manual")}
        />
      </Box>
    </Box>
  );
};

export default VCSIntegrationsManageGitHubEnterpriseHeader;
